import { render, staticRenderFns } from "./productcenter1.vue?vue&type=template&id=64e65daf&scoped=true&"
import script from "./productcenter1.vue?vue&type=script&lang=js&"
export * from "./productcenter1.vue?vue&type=script&lang=js&"
import style0 from "./productcenter1.vue?vue&type=style&index=0&id=64e65daf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e65daf",
  null
  
)

export default component.exports